import React, { Component } from "react";
import { Modal } from "react-bootstrap";

class DeleteOrderModal extends Component {

    render() {

        const {
            show,
            order,
            deleting,
            onClose,
            onConfirm
        } = this.props;

        return (
            <Modal
                show={show}
                onHide={onClose}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Supprimer la commande
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <p>
                        Voulez-vous vraiment supprimer cette commande ?
                    </p>

                    {
                        order &&
                        <div className="alert alert-warning">

                            <div>
                                <strong>Référence :</strong>{" "}
                                {
                                    order.reference ||
                                    order.orderReference ||
                                    order.orderId
                                }
                            </div>

                            {
                                order.description &&
                                <div className="mt-2">
                                    {order.description}
                                </div>
                            }

                        </div>
                    }

                    <div className="text-danger">
                        Cette opération est irréversible.
                        Une commande contenant des produits ne peut pas être supprimée.
                    </div>

                </Modal.Body>

                <Modal.Footer>

                    <button
                        className="btn btn-secondary"
                        onClick={onClose}
                        disabled={deleting}
                    >
                        Annuler
                    </button>

                    <button
                        className="btn btn-danger"
                        onClick={onConfirm}
                        disabled={deleting}
                    >
                        {
                            deleting
                                ? "Suppression..."
                                : "Supprimer"
                        }
                    </button>

                </Modal.Footer>

            </Modal>
        );
    }
}

export default DeleteOrderModal;